import React from 'react';

export interface BreakdownQuestion {
  questionText: string;
  options: { A: string; B: string; C: string; D: string };
  correctAnswer: string;
  selectedAnswer: string;
  isCorrect: boolean;
}

interface QuizBreakdownProps {
  questions: BreakdownQuestion[];
  title?: string;
  className?: string;
}

const QuizBreakdown: React.FC<QuizBreakdownProps> = ({
  questions,
  title = 'Quiz Breakdown',
  className = '',
}) => {
  if (!questions || questions.length === 0) return null;

  return (
    <section className={`quiz-breakdown card ${className}`.trim()}>
      {title ? <h2 className="quiz-breakdown__title">{title}</h2> : null}
      <ol className="quiz-breakdown__list">
        {questions.map((q, i) => (
          <li
            key={i}
            className={`quiz-breakdown__item ${q.isCorrect ? 'quiz-breakdown__item--correct' : 'quiz-breakdown__item--incorrect'}`}
          >
            <span className="quiz-breakdown__badge" aria-hidden="true">
              {q.isCorrect ? '✓' : '✗'}
            </span>
            <div className="quiz-breakdown__content">
              <p className="quiz-breakdown__question">{q.questionText}</p>
              <p className="quiz-breakdown__answer">
                Your answer: {q.selectedAnswer ? (q.options[q.selectedAnswer as keyof typeof q.options] ?? q.selectedAnswer) : '—'}
                {!q.isCorrect && q.correctAnswer && (
                  <span className="quiz-breakdown__correct">
                    {' '}· Correct: {q.options[q.correctAnswer as keyof typeof q.options]}
                  </span>
                )}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default QuizBreakdown;
